import Handlebars from "handlebars";
import Commons from "../Commons.js";
import Doms from "../Doms.js";
import I18N from "oc-I18N";

function unsafeString(closure) {
    return function(...args) {
        return closure(...(args.map(a=>a instanceof Handlebars.SafeString ? a.string : a)));
    }
}

Doms.handlebarsRegisterSafe({

    /**
     * encodeURIComponent auf einer uri
     */
    encodeURIComponent (uri) {
        return encodeURIComponent(uri);
    },

    /**
     * gibt den Wert einer globalen Variable zurück
     */
    global_var (name_of_global_variable) {
        if (name_of_global_variable==null) {
            return 'error: {{global_var null}}!';
        }
        return eval(name_of_global_variable);
    },

    /**
     * entfernt alle Whitespaces
     */
    removeWhitespaces (srcString) {
        if (srcString == null) {
            return "";
        }
        return srcString.replace(/\s/g, "");
    },

    /**
     * ersetzt in einem String einen regulären Ausdruck global mit einem Replacement
     */
    replace(srcString,searchRegexPattern,replace) {
        if (srcString == null) {
            return "";
        }
        srcString = ""+srcString;
        return srcString.replace(new RegExp(searchRegexPattern,"g"), replace);
    },

    /**
     * Pendant zur serverseitigen PHP-Funktion Helper::safeFileName. Somit können z.B. normalisierte Dateinamen abgefragt werden.
     */
    safeFileName(name) {
        return Commons.safeFileName(name);
    },

    /**
     * javascripts substring
     */
    substring (str, start, end) {
        if (str == null) {
            return "";
        }
        return str.substring(start, end);
    },

    /**
     * javascript regex match
     */
    match (str, needle) {
        return str.match(new RegExp(needle, 'i'));
    },

    /**
     * Concatiniert die Aufrufparameter, baut daraus einen Selektor und gibt den Inhalt des darauf matchenden HTML-Elementes zurück.
     * @example
     * {{insert_content_of_element_with_selector ".menu" ".selected"}}
     * &lt;div class=&quot;menu selected&quot;&gt;Hello World&lt;/div&gt;
     * => ersetzt den Aufruf durch "Hello World"
     */
    insert_content_of_element_with_selector () {
        var selector = _.slice(arguments, 0, arguments.length - 1).join('');
        return new Handlebars.SafeString($(selector).html());
    },

    /**
     * Concatiniert alle Aufrufparameter
     * @example
     * {{join "A" "B"}}
     * => ersetzt den Aufruf durch "AB"
     */
    join(){
        return Array.from(arguments).slice(0,-1).join('');
    },

    /**
     * Fallunterscheidung, vergleicht zwei Werte miteinander, wobei alle Javascript-Vergleichsoperatoren wie == oder <= unterstützt werden.
     * @example
     * {{#compareVal (global_var 'CURRENT_USER_ROLE') '==' 'admin'}}
     * Hallo Admin
     * {{else}}
     * Forbidden!
     * {{/compareVal}}
     */
    compareVal (lvalue, operator, rvalue, options) {
        var operators, result;

        if (arguments.length < 3) {
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        }

        if (options === undefined) {
            options = rvalue;
            rvalue = operator;
            operator = "===";
        }

        operators = {
            '==' (l, r) { return l == r; },
            '===' (l, r) { return l === r; },
            '!=' (l, r) { return l != r; },
            '!==' (l, r) { return l !== r; },
            '<' (l, r) { return l < r; },
            '>' (l, r) { return l > r; },
            '<=' (l, r) { return l <= r; },
            '>=' (l, r) { return l >= r; },
            'in' (l, r) { return r.split(',').indexOf(l)!=-1; },
            'typeof' (l, r) { return typeof l == r; }
        };

        if (!operators[operator]) {
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        }

        result = operators[operator](lvalue, rvalue);

        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    },

    /**
     * diverse Vergleichsoperatoren
     */
    '==': unsafeString((l, r) => l == r),
    '===': unsafeString((l, r) => l === r),
    'not': unsafeString((l) => !l),
    '!': unsafeString((l) => !l),
    '!=': unsafeString((l, r) => l != r),
    '!==': unsafeString((l, r) => l !== r),
    '<': unsafeString((l, r) => l < r),
    '>': unsafeString((l, r) => l > r),
    '<=': unsafeString((l, r) => l <= r),
    '>=': unsafeString((l, r) => l >= r),
    'in': unsafeString((l, r) => _.isString(r) && r.split(',').indexOf(l)!=-1),
    'typeof': unsafeString((l, r) => typeof l == r),
    '||': unsafeString((l, r) => l || r),
    '&&': unsafeString((l, r) => l && r),
    '++': (n)=>n+1,
    '--': (n)=>n-1,

    /**
     * prüft, ob ein Wert leer oder null ist
     */
    empty(value) {
        return Commons.isEmpty(value);
    },

    /**
     * Kobiniert alle argumente mit and
     * @example
     * {{#and variable1 variable2}}
     * variable1 && variable2 == true
     * {{else}}
     * variable1 && variable2 == false
     * {{/and}}
     */
    and (...args){
        let result=true;
        const options=args[args.length-1];
        for (let i=0;i<args.length-1;i++){
                result&=args[i];
        }
        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    },
    /**
     * Kobiniert alle argumente mit or
     * @example
     * {{#and variable1 variable2}}
     * variable1 && variable2 == true
     * {{else}}
     * variable1 && variable2 == false
     * {{/and}}
     */
    or (...args){
        let result=false;
        const options=args[args.length-1];
        for (let i=0;i<args.length-1;i++){
            result|=args[i];
        }
        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    },

    /**
     * Gibt value zurück, falls gesetzt, ansonsten default
     * @returns {Handlebars.SafeString}
     */
    valueOrDefault(value, default_) {
        const out = value==null ? default_ : value;
        return new Handlebars.SafeString(out);
    },

    /**
     * gibt eine HTML-Attributsdefinition zurück (name="value"), falls value ungleich null ist, sonst den Leerstring
     */
    attrIfValue(name, value) {
        if (value!=null) {
            const valueStr = _.isString(value) ? `"${value}"` :
                ( value instanceof Handlebars.SafeString ? `"${value.string}"` : `${value}` );
            return new Handlebars.SafeString(`${name}=${valueStr}`);
        } else {
            return "";
        }
    },

    /**
     * Ist als {{{{raw}}}} - Block gedacht (siehe raw-blocks unter http://handlebarsjs.com/block_helpers.html)
     * @param options
     */
    raw (options) {
        const hbs = options.hash.hbs;
        if (hbs) {
            return HBS(hbs).template;
        }
        return options.fn();
    },

    /**
     * Gibt def zurück falls test leerstring oder undefined oder null, sonst test
     * @param test zu testender Wert
     * @param def  default Wert
     */
    defaultValue(test,def){
        if (test==null || test===''){
            return def;
        }
        return test;
    },

    /**
     * Formatiert eine Zahl als Währungsbetrag in der landestypischen Art
     * @example
     * 12.345,67 €
     */
    formatCurrency (value,digits=null) {
        const options={
            style: 'currency',
            currency: APP.settings.currency ? APP.settings.currency : 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true
        };
        if (Number.isInteger(digits)){
            options.minimumFractionDigits=digits;
            options.maximumFractionDigits=digits;
        }

        return (value==null ? 0 : value).toLocaleString(I18N.getLanguage(),options);
    },

    /**
     * Formatiert eine Zahl in der landestypischen Art
     * @example
     * 12.345,67
     */
    formatNumber (value,fractionDigits=null) {
        if (value==null) {
            return '0';
        }
        const localeOptions = {
            style: 'decimal',
            useGrouping: true,
        };
        if (_.isNumber(fractionDigits)) {
            localeOptions.minimumFractionDigits=fractionDigits;
            localeOptions.maximumFractionDigits=fractionDigits;
        }
        return value.toLocaleString(I18N.getLanguage(),localeOptions);
    },

    /**
     * Formatiert eine Zahl als Prozent in der landestypischen Art
     * @example
     * 43 %
     */
    formatPercent(value,options) {
        if (value==null) {
            return '0 %';
        }
        return value.toLocaleString(I18N.getLanguage(),{
            style: 'percent',
        });
    },

    ifArrayThenElementAtIndex(arr,index){
        if (Array.isArray(arr) && arr.length>index){
            return arr[index];
        }
        return null;
    },

    /**
     * Gibt einen Sprach-Key (erster Parameter) in im Browser eingestellten Sprache aus. Es können optional beliebig
     * viele weitere Parameter folgen, welche in den Sprachtext eingefügt werden, falls dieser Platzhalter enthält,
     * siehe I18N - Klasse.
     * @example
     * {{I18N "HelloWorld"}}
     * // Sprachtext: "HelloWorld": "Servus Welt!" => "Servus Welt!"
     * {{I18N "HelloXY" "Peter"}}
     * // Sprachtext: "HelloXY": "Servus %s!" => "Servus Peter!"
     */
    I18N: function(key) {
        return new Handlebars.SafeString(I18N.apply(null,arguments));
    },

    /**
     * Sucht im DOM nach einem Element und übersetzt dessen Inhalt als Handlebars-Template und fügt das
     * Ergebnis ein. Dient z.B. dazu, um CMS-Content von PHP aus auf der Seite als Template verfügbar zu machen.
     * @example
     * {{selectorTemplate "#myTemplate"}}
     * ...
     * &lt;script id=&quot;myTemplate&quot; type=&quot;text/x-handlebars-template&quot;&gt;
     *    Hello {{name}}!
     * &lt;/script&gt;
     */
    selectorTemplate: function(selector,options) {
        const element = $(selector);
        if (element.length == 0) {
            const message = '$("'+selector+'") not found';
            console.error(message);
            return message;
        }
        const template = $(selector).html();
        const html = Handlebars.compile(template,options)(this);
        return new Handlebars.SafeString(html);
    },

    /**
     * {{#each XXX }}
     *   {{#ifIsNthItem nth=5}}
     * Body wird jedes 5te Mal evaluiert
     */
    ifIsNthItem: function (options) {
        var index = options.data.index + 1,
            nth = options.hash.nth;

        if (index % nth === 0)
            return options.fn(this);
        else
            return options.inverse(this);
    },


    /**
     * Für Debug-Zwecke: gibt den aktuellen Context und die übergebenen Parameter
     * auf der Console aus und als Text zurück
     */
    log: function(...args) {
        const values = [this,...args.slice(0,-1),args[args.length-1].hash];
        console.log('HandlebarsExtensions.log:', values);
        return JSON.stringify(values,null,3);
    },

    /**
     * Zählt die Anzahl der Elemente eines Arrays
     */
    count: function(value) {
        return value && value.length ? value.length : 0;
    },

    /**
     * Terniärer Operator: condition ? a : b
     */
    iif: function(condition,a,b) {
        return condition ? a : b;
    },


    ifVariableValue(variable,value,options){
        const result=APP.arrangement.variables[variable]==value;
        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    },


    /**
     * gibt den aktuellen Timestamp als Anzahl der Millisekunden dieser Epoche zurück
     * @return {number}
     */
    now: function() {
        return Date.now();
    },

    dateLocaleDate:function (datestring){

        return new Date(datestring).toLocaleDateString();

    }
    ,
    dateLocaleTime:function (datestring){

        return new Date(datestring).toLocaleTimeString();
    },
    dateLocale:function (datestring){

        return new Date(datestring).toLocaleString();
    },


    isString: function(data){
        return typeof data === 'string';
    },

    defaultsDeep: function(...args){
        return Commons.defaultsDeepSafe({},...(args.filter((a,i)=>a!=null && i<args.length-1)));
    },

    times: function(n, block) {
        var accum = '';
        for(var i = 0; i < n; ++i)
            accum += block.fn(n);
        return accum;
    }

});
